module.exports = __webpack_public_path__ + "img/right_arrow.1b5994b9.svg";